enum NarrativeTypes {
  VIN_WHY_BUY = 'VIN_WHY_BUY'
}

export default NarrativeTypes;
